export type ThemeType = "DARK" | "LIGHT";

export const THEMES: Record<ThemeType, ThemeType> = {
  LIGHT: "LIGHT",
  DARK: "DARK",
};
